import AddIcon from "@mui/icons-material/Add";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Box,
  Container,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextField from "../../../components/CustomTextField";
import { default as Select } from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import { createNewChat } from "../../../redux/reducers/chatSlice";
import {
  getClinicPetList,
  getClinicPets,
  updatePetStatusById,
} from "../../../redux/reducers/petSlice";
import { AppColors } from "../../../util/AppColors";
import {
  bloodGroups,
  genderList,
  NeuteredList,
  petOwnershipTypeList,
  temperaments,
} from "../../../util/dropList";
import { getPetSearchType } from "../../../util/function";
import { tblGrayBack } from "../../../util/object";
import CreateClinicPet from "../../CommonComponents/CreateClinicPet";
import BookAnAppointment from "../../CommonScreens/BookAppointmentment/BookAnAppointment";

const tblHeaders = [
  "patientId",
  "petName",
  "breed",
  "gender",
  "userName",
  "combined",
  // "status",
  // "chat",
  // "book",
];
const nameExpan = {
  patientId: "Patient ID",
  userName: "User Name",
  petName: "Pet Name",
  breed: "Breed",
  gender: "Gender",
  // chat: "",
  // book: "",
  combined: "",
};

const initSearch = { patientId: "", petName: "", userName: "", phone: "" };
const filterByList = [
  "Ownership Type",
  "Email",
  // "Secondary Phone Number",
  "Species",
  // "Breed",
  "Color",
  "Gender",
  "Reproductive Status",
  "Blood Group",
  "Temperament",
];
const dropFields = [
  "Ownership Type",
  "Species",
  // "Breed",
  "Gender",
  "Reproductive Status",
  "Blood Group",
  "Temperament",
];
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: { type: "all" },
};

const ClinicPetsTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalBookVisible, setBookModVisible] = useState(false);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [searchValue, setSearchValue] = useState("");
  const [selectPet, setSelectPet] = useState(null);
  const [createModVisible, setCreateModalVisible] = useState(false);
  const [filterValues, setFilterValues] = useState(initFilter);
  const [page, setPage] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedStep, setSelectedStep] = useState(0);
  const {
    clinicPets: pets,
    types,
    clinicPetList,
  } = useSelector((state) => state?.pet);
  const itemSize = 10;
  const defaultUrl = `?type=all&page=1&itemSize=${itemSize}`;

  useEffect(() => {
    //for calling the init api call to load the data
    // onPetsApiCall(1, true);

    // Reset filter values to initial state when component mounts
    setFilterValues({
      ...initFilter,
      selectedList: [],
      values: { type: "all" },
    });
  }, []);

  useEffect(() => {
    // Only call API if there are actual search values
    // const hasSearchValues =
    //   searchValues?.patientId?.trim() ||
    //   searchValues?.petName?.trim() ||
    //   searchValues?.userName?.trim() ||
    //   searchValues?.phone?.trim();
    // if (hasSearchValues) {
    onPetsApiCall();
    // }
  }, [
    searchValues?.patientId,
    searchValues?.petName,
    searchValues?.userName,
    searchValues?.phone,
  ]);

  const getFilterObj = (currentPage = 1, reset = false) => {
    setPage(currentPage);
    const reqObj = {
      type: filterValues?.values?.type,
      page: currentPage,
      itemSize: itemSize,
    };
    if (reset) return reqObj;
    if (searchValues?.patientId?.length > 0)
      reqObj.patientId = searchValues?.patientId;
    if (searchValues?.petName?.length > 0)
      reqObj.petName = searchValues?.petName;
    if (searchValues?.userName?.length > 0)
      reqObj.username = searchValues?.userName;
    if (searchValues?.phone?.length > 0)
      reqObj.phoneNumber = searchValues?.phone;
    if (filterValues?.values?.Email?.length > 0)
      reqObj.email = filterValues?.values?.Email;
    if (filterValues?.values?.["Ownership Type"]?.length > 0)
      reqObj.ownershipType =
        filterValues?.values?.["Ownership Type"] === "all"
          ? ["household", "rescue"]
          : [filterValues?.values?.["Ownership Type"]];
    // if (filterValues?.values?.["Secondary Phone Number"]?.length > 0)
    //   reqObj.SecondaryPhoneNumber = filterValues?.values?.["Secondary Phone Number"];
    if (filterValues?.values?.Species?.length > 0)
      reqObj.species = filterValues?.values?.Species?.map((li) => li?.value);
    if (filterValues?.values?.Color?.length > 0)
      reqObj.color = filterValues?.values?.Color;
    if (filterValues?.values?.Gender?.length > 0)
      reqObj.gender = filterValues?.values?.Gender?.map((li) => li?.value);
    if (filterValues?.values?.["Reproductive Status"]?.length > 0)
      reqObj.reproductiveStatus = filterValues?.values?.[
        "Reproductive Status"
      ]?.map((li) => li?.value);
    if (filterValues?.values?.["Blood Group"]?.length > 0)
      reqObj.bloodGroup = filterValues?.values?.["Blood Group"]?.map(
        (li) => li?.value
      );
    if (filterValues?.values?.Temperament?.length > 0)
      reqObj.temperament = filterValues?.values?.Temperament?.map(
        (li) => li?.value
      );
    return reqObj;
  };

  const onPetsApiCall = (currentPage = 1, reset = false) => {
    dispatch(getClinicPetList(getFilterObj(currentPage, reset)));
  };

  const onApplyFilter = () => {
    onPetsApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  // useEffect(() => {
  //   dispatch(
  //     getClinicPets(
  //       `?type=all${getPetSearchType(searchValue)}&page=1&itemSize=${itemSize}${
  //         searchValue?.length > 0 ? `&search=${searchValue}` : ""
  //       }`
  //     )
  //   );
  //   setPage(1);
  // }, [searchValue]);

  const bookAppointment = (li) => {
    setSelectPet(li);
    setBookModVisible(true);
  };

  const handleCreate = () => {
    setCreateModalVisible(true);
  };

  const getClinicPetsData = () => {
    setSearchValue("");
    dispatch(getClinicPets(defaultUrl));
  };

  const onCloseCreateMod = (e) => {
    setSelectedUser(null);
    setSelectedStep(0);
    if (e === "petCreated") getClinicPetsData();
    setCreateModalVisible(!createModVisible);
  };

  const getPetTypes = () => {
    return (types ?? [])?.map((sp) => ({
      name: sp?.speciesName,
      value: sp?.speciesName,
      speciesId: sp?.speciesId,
    }));
  };

  const handleClickPet = (pet) => {
    return navigate("/clinic-pet-details", {
      state: {
        appointment: {
          appoinment: {
            appointmentId: pet?.appointmentId ?? null,
            petId: pet?.listOfDatas?.petId,
          },
        },
        inpatientId: pet?.inpaitentId,
      },
    });
  };

  const onClickMessageIcon = (e) => {
    dispatch(createNewChat(e?.userId)).then((res) => {
      if (res?.payload) {
        navigate("/chat", { state: { chatId: res?.payload?.chatId } });
      }
    });
  };

  const updatePetStatus = (petId, status) => {
    dispatch(updatePetStatusById({ petId, status })).then((res) => {
      if (res?.payload) {
        dispatch(
          getClinicPets(
            `?type=all${getPetSearchType(
              searchValue
            )}&page=1&itemSize=${itemSize}${
              searchValue?.length > 0 ? `&search=${searchValue}` : ""
            }`
          )
        );
      }
    });
  };

  const onAddPet = (petDet) => {
    setSelectedUser(petDet);
    setSelectedStep(1);
    setCreateModalVisible(true);
  };

  const getTableRecords = () => {
    if (clinicPetList?.pets?.length === 0 || !clinicPetList?.pets) return [];
    return clinicPetList?.pets?.map((pt) => {
      const pet = pt?.listOfDatas;
      return {
        appointmentId: pt?.appointmentId,
        inpaitentId: pt?.inpaitentId,
        patientId: pet?.oldPatientId
          ? pet?.oldPatientId?.split(".").shift()
          : "-",
        userName: (
          <div>
            <Custom3dotString
              str={pet?.userName}
              className="font-medium fs14"
              length={15}
            />
            <div className="font-medium fs12 gray15">
              No. of Pets: {pt?.totalPets ?? 0}
            </div>
          </div>
        ),
        petName: (
          <div onClick={() => handleClickPet(pt)}>
            <Custom3dotString
              str={pet?.petName === "No pets registered" ? "" : pet?.petName}
              className="font-bold fs14 cursor blue-color underline"
              length={15}
            />
          </div>
        ),
        breed: pet?.breed,
        gender: (
          <Typography
            className={`capitalize font-medium fs12 ${
              pet?.gender === "male" ? "card-blue-color" : "card-rose-color"
            }`}
          >
            {pet?.gender}
          </Typography>
        ),
        combined: (
          <div className="flex-row-ali-cen flex1-end">
            {pet?.petId ? (
              <>
                <div>
                  <CustomSwitch
                    value={pet.status}
                    onChange={(e) => updatePetStatus(pet?.petId, !pet?.status)}
                    greenToGray
                  />
                </div>
                <div className="ml15">
                  <MessageOutlinedIcon
                    className="yellow-color cursor"
                    onClick={() => onClickMessageIcon(pet)}
                    sx={{ width: 25, height: 25 }}
                  />
                </div>
              </>
            ) : null}
            <div className="ml15">
              <CustomButton
                text="+ Add Pet"
                onClick={() => onAddPet(pet)}
                smallBtn
              />
            </div>
            {pet?.petId ? (
              <div className="ml15">
                <CustomButton
                  text="Book"
                  onClick={() => bookAppointment(pet)}
                  smallBtn
                />
              </div>
            ) : null}
          </div>
        ),
        // status: (
        //   <CustomSwitch
        //     value={pet.status}
        //     onChange={(e) => updatePetStatus(pet?.petId, !pet?.status)}
        //     greenToGray
        //   />
        // ),
        // chat: (
        //   <MessageOutlinedIcon
        //     className="img-wh35 yellow-color cursor"
        //     onClick={() => onClickMessageIcon(pet)}
        //   />
        // ),
        // book: (
        //   <div style={{ width: 100 }}>
        //     <CustomButton
        //       text="Book"
        //       onClick={() => bookAppointment(pet)}
        //       smallBtn
        //     />
        //   </div>
        // ),
        userId: pet?.userId,
      };
    });
  };

  const handleChangePage = (e, selectedPage) => {
    onPetsApiCall(selectedPage);
    // dispatch(
    //   getClinicPets(
    //     `?type=all${getPetSearchType(
    //       searchValue
    //     )}&page=${selectedPage}&itemSize=${itemSize}${
    //       searchValue?.length > 0 ? `&search=${searchValue}` : ""
    //     }`
    //   )
    // );
    // setPage(selectedPage);
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({
        ...initFilter,
        selectedList: [],
        values: { type: "all" },
      });
    });
    onPetsApiCall(1, true);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onPetsApiCall();
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: { type: "all" },
    };
    setFilterValues(reqObj);
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Toolbar variant="regular">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <div className="top-row-cen-con w100Per">
                  <div className="w15Per">
                    <CustomTextField
                      placeholder="Patient ID"
                      fullWidth
                      name="patientId"
                      handleChange={onSearchChange}
                      value={searchValues?.patientId}
                      backgroundColor={AppColors.lightBlue2}
                      label="Patient ID"
                    />
                  </div>
                  <div className="w15Per ml20">
                    <CustomTextField
                      placeholder="Pet Name"
                      fullWidth
                      name="petName"
                      handleChange={onSearchChange}
                      value={searchValues?.petName}
                      backgroundColor={AppColors.lightBlue2}
                      label="Pet Name"
                    />
                  </div>
                  <div className="w15Per ml20">
                    <CustomTextField
                      placeholder="User Name"
                      fullWidth
                      name="userName"
                      handleChange={onSearchChange}
                      value={searchValues?.userName}
                      backgroundColor={AppColors.lightBlue2}
                      label="User Name"
                    />
                  </div>
                  <div className="w15Per ml20">
                    <CustomTextField
                      placeholder="Phone Number"
                      fullWidth
                      name="phone"
                      handleChange={onSearchChange}
                      value={searchValues?.phone}
                      backgroundColor={AppColors.lightBlue2}
                      label="Phone Number"
                    />
                  </div>
                  <div
                    className="flex-row-ali-cen ml20 filter cursor"
                    onClick={() => onFilterChange("visible", true)}
                  >
                    <TuneIcon sx={{ color: AppColors.appPrimary }} />
                    <Typography className="font-medium fs12 blue-color ml10">
                      {filterValues?.selectedList?.length > 0
                        ? `${filterValues?.selectedList?.length} `
                        : ""}
                      Filter
                    </Typography>
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Reset"
                      onClick={onReset}
                      smallBtn
                      redBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Create"
                      onClick={handleCreate}
                      smallBtn
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Toolbar>
          <Typography className="font-medium fs12 gray28">
            Number of Pets: {clinicPetList?.totalRecords ?? 0}
          </Typography>
        </Container>
      </TopBar>

      <Box className="pb-40 ph20">
        <TableContainer sx={{ maxHeight: 450 }} className="mb20">
          <Table
            sx={{ minWidth: 200 }}
            aria-labelledby="tableTitle"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {tblHeaders?.map((hdr, i) => (
                  <TableCell
                    key={i}
                    style={tblGrayBack}
                    className="txt-semi-bold fs12"
                  >
                    <div
                      style={{
                        width:
                          hdr === "userName" || hdr === "petName"
                            ? 200
                            : hdr === "chat"
                            ? 80
                            : hdr === "breed"
                            ? 150
                            : hdr === "combined"
                            ? 300
                            : 100,
                      }}
                    >
                      {nameExpan?.[hdr]}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {clinicPetList?.pets?.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} className="text-align-center h100">
                  <div className="no-rec">No records available</div>
                </TableCell>
              </TableRow>
            )}
            <TableBody>
              {getTableRecords()?.map((li, i) => {
                return (
                  <TableRow key={i}>
                    {tblHeaders?.map((hdr, ind) => (
                      <TableCell key={ind + i + "tr"} component="th">
                        <div
                          style={{
                            width:
                              hdr === "userName" || hdr === "petName"
                                ? 200
                                : hdr === "chat"
                                ? 80
                                : hdr === "breed"
                                ? 150
                                : hdr === "combined"
                                ? 300
                                : 100,
                          }}
                        >
                          {li?.[hdr]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
            {Math.ceil(clinicPetList?.totalRecords / itemSize) > 1 ? (
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={12}>
                    <div className="flex-end">
                      <Pagination
                        count={Math.ceil(
                          clinicPetList?.totalRecords / itemSize
                        )}
                        variant="outlined"
                        color="primary"
                        page={page}
                        onChange={handleChangePage}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              </TableFooter>
            ) : null}
          </Table>
        </TableContainer>
      </Box>

      {modalBookVisible ? (
        <BookAnAppointment
          modalVisible={modalBookVisible}
          setBookModVisible={setBookModVisible}
          selectedPet={selectPet}
        />
      ) : null}
      {/* {createModVisible ? ( */}
      <CreateClinicPet
        createModVisible={createModVisible}
        onCloseCreateMod={onCloseCreateMod}
        setBookModVisible={setBookModVisible}
        setSelectPet={setSelectPet}
        userDetails={selectedUser}
        selectedStep={selectedStep}
      />
      {/* ) : null} */}

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {dropFields?.includes(li) ? (
                          <Select
                            list={
                              li === "Ownership Type"
                                ? petOwnershipTypeList
                                : li === "Species"
                                ? getPetTypes()
                                : li === "Gender"
                                ? genderList
                                : li === "Reproductive Status"
                                ? NeuteredList
                                : li === "Blood Group"
                                ? bloodGroups
                                : li === "Temperament"
                                ? temperaments
                                : []
                            }
                            value={filterValues?.values?.[li] ?? []}
                            name={li}
                            handleChange={onFilterValuesChange}
                            label={li}
                            multiSelectSearchCheck={li !== "Ownership Type"}
                            select={li === "Ownership Type"}
                          />
                        ) : (
                          <CustomTextField
                            placeholder={li}
                            fullWidth
                            name={li}
                            handleChange={onFilterValuesChange}
                            value={filterValues?.values?.[li] ?? ""}
                            label={li}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default ClinicPetsTable;
